import { render, staticRenderFns } from "./HelpPanel.vue?vue&type=template&id=2f1bc0d0&scoped=true&"
import script from "./HelpPanel.vue?vue&type=script&lang=js&"
export * from "./HelpPanel.vue?vue&type=script&lang=js&"
import style0 from "./HelpPanel.vue?vue&type=style&index=0&id=2f1bc0d0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f1bc0d0",
  null
  
)

export default component.exports